import { Select } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useSettings } from '../hooks/useSettings';
import { ComponentsDispatch, RootState } from '../store';
import { setterCalendar } from '../store/slices/calendarSlice';
import { CalendarScaleType, CalendarViewType } from '../types';

const options: { label: string; value: CalendarScaleType }[] = [
    { label: 'Day', value: 'day' },
    { label: 'Week', value: 'week' },
    // { label: 'Month', value: 'month' },
    // { label: 'Year', value: 'year' },
];

const ButtonScale = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const scheduleScale = useSelector<RootState, CalendarScaleType>((state) => state.calendar.scheduleScale);
    const view = useSelector<RootState, CalendarViewType>((state) => state.calendar.viewCalendar);

    const { saveUserSettings } = useSettings();

    const onChangeScale = (scheduleScale: CalendarScaleType) => {
        dispatch(setterCalendar({ scheduleScale }));

        saveUserSettings({
            calendarScale: scheduleScale,
        });
    };

    const disableFor = new Set<CalendarViewType>(['agenda', 'list', 'table']);

    return (
        <Select
            style={{ width: 120 }}
            value={scheduleScale}
            options={options}
            onChange={onChangeScale}
            disabled={disableFor.has(view)}
        />
    );
};

export default ButtonScale;
